import { BadgeV3 } from '@cimplico/components';

function BusinessStructureBadge({ type }: { type?: string | null }): JSX.Element {
    if (!type) {
        return <BadgeV3 rounded={false} label="Other" color="gray" />;
    }
    const _type = type?.toLowerCase();

    if (_type === 'company') {
        return <BadgeV3 rounded={false} label={type} color="violet" />;
    }
    if (_type === 'trust') {
        return <BadgeV3 rounded={false} label={type} color="pink" />;
    }
    if (_type === 'sole trader') {
        return <BadgeV3 rounded={false} label={type} color="blue" />;
    }
    if (_type === 'partnership') {
        return <BadgeV3 rounded={false} label={type} color="red" />;
    }
    if (_type === 'individual') {
        return <BadgeV3 rounded={false} label={type} color="yellow" />;
    }

    return <BadgeV3 rounded={false} label={type} color="orange" />;
}

export default BusinessStructureBadge;
